export default __webpack_public_path__ + "static/media/pizza-2-640w.b41bf876.jpg";